import { render, staticRenderFns } from "./MedicineByLetter.vue?vue&type=template&id=1910abf3&scoped=true&"
import script from "./MedicineByLetter.vue?vue&type=script&lang=js&"
export * from "./MedicineByLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1910abf3",
  null
  
)

export default component.exports